import React from "react";

import Breadcrumbs from "../../../../components/BreadCrumbs";
import Card from "../../../../components/Card";
import { UIPageFormFooter } from "../../../../components/ui";
import ClientFormFields from "../../../Company-portal/Clients/ClientForm/ClientFormFields";
import useAdminAddClient from "../hooks/useAdminAddClient";

import "../../../Company-portal/Clients/ClientForm/ClientForm.scss";

const AdminAddClient = () => {
  const {
    clients,
    shared,
    inputsValidations,
    breadcrumbList,
    creating,
    canAdd,
    formik,
    onCancel,
  } = useAdminAddClient();

  if (!canAdd) return null;

  return (
    <div className="company-client-form add-client">
      <Breadcrumbs list={breadcrumbList} BreadCrumbHasBackIcon={false} />

      <h2 className="page-title">{clients.addClient.addNewClientTitle}</h2>

      <form onSubmit={formik.handleSubmit}>
        <Card
          title={clients.details}
          classNames={{ body: "company-portal-profile-card__body" }}
        >
          <ClientFormFields
            clients={clients}
            formik={formik}
            inputsValidations={inputsValidations}
          />
        </Card>

        <UIPageFormFooter
          cancelLabel={shared.cancel}
          submitLabel={shared.confirm}
          onCancel={onCancel}
          submitType="submit"
          submitDisabled={!formik.dirty || !formik.isValid || creating}
          submitLoading={creating}
          cancelDisabled={creating}
        />
      </form>
    </div>
  );
};

export default AdminAddClient;
